import styled, { css } from 'styled-components';

export const StyledUnaccompaniedImageWrapper = styled.div`
  display: flex;
  justify-content: ${props => props.alignImage};
  margin-bottom: 15px;
`;

export const StyledFigCaption = styled.figcaption`
  display: flex;
  justify-content: center;
  margin: 5px 0px 10px 0px;
  font-size: 12px;
  color: rgb(70, 52, 78);
`;

export const StyledUnaccompaniedImage = styled.img`
  display: flex;
  max-width: 100%;
  padding-top: 0.5em;
  padding-bottom: ${props => props.hasCaption ? '0px' : '1em'};
  margin: auto;
`;

export const ColumnWrap = styled.section`
  width:100%;
  display:block;
  

  @media(min-width:600px){
    display:flex;
    flex-direction:row;
    /* padding: 0.5em 0 1em 0; */
  }

   &:nth-of-type(1) {
    h1, h2, h3, h4, h5, h6 {
      margin-top: 0;
    }
  }
  
 img {
  display: block;
  max-width: 100%;
  margin-bottom: 0.5em;
  max-height: 450px;

  @media(min-width:600px){
    display : ${props => props.leftAlign || !props.leftAlign ? "inline-block" : "block"}
  }
 }

 @media (min-width:600px) {
    width: 100%;
    max-width: 100%;
  }


  ${props => !props.wrapText && css`
   div {
     overflow:unset;
   }
   @media(min-width:600px){
      overflow:hidden;
      div {
        overflow: hidden;
      }
   }
    
  `};
`

export const RichtextStyle = styled.section`
  width:100%;

  @media(min-width:600px){
    order: ${props => props.leftAlign ? 2 : 1};
  }

`

export const FigStyle = styled.figure`
  position:relative;
  width: ${props => {
    if (props.custom === "keep native width") {
      return "initial"
    } else if (props.custom === "full width") {
        return "100%"
    } else if (props.custom) {
      return props.custom
    }
  }};
  margin: 0;
  
  img {
    width: 100%;
    min-width: ${props => props.dimensions < 50 ? "auto" : "200px"};
    max-height: ${props=> props.custom === "full width" && "none"};
    margin-bottom: ${props => props.hasCaptions && "0px"};
  }

  @media(min-width:600px){
    width: ${props => {
      if (props.custom === "keep native width") {
        return "initial"
      } else if (props.custom === "full width") {
        return "100%"
      } else if (props.custom) {

        return props.custom
      }
    }};
  }

  ${props => props.leftAlign && 
    css`
      @media(min-width:600px) {
        order: 1;
        float:left;
        margin-right:1.2em !important;
        margin-bottom: 1em;
      }
    `
  }

  ${props => props.custom === "100%" &&
    css`
      @media(min-width:600px){
        margin-bottom: 0;
      }
    `
  }

  ${props => !props.leftAlign && 
    css`
      @media(min-width:600px){
        order: 2;
        float:right;
        margin-left:1.2em !important;
        margin-bottom: 1em;
      }
    `
  }
`

export const FigCaptionStyle = styled.figcaption`
  margin-bottom:0.5em;
  text-align:center;
  bottom:-20px;
`

export const CaptionStyle = styled.small`
  font-size: 13px;
  line-height: 21px;
`